import { render, staticRenderFns } from "./adsBox.vue?vue&type=template&id=249517ec"
import script from "./adsBox.vue?vue&type=script&lang=js"
export * from "./adsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports